module.exports = __webpack_public_path__ + "img/yellowcircle.6382e05a.svg";